// extracted by mini-css-extract-plugin
export default {"overlay":"TooltipWrapper_overlay__4c2MU"};